import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    neutral: {
      main: "#555A4D",
    },
    primary: {
      main: "#2ED2BD",
    },
    danger: {
      main: "#2E3D34",
    },
  },
});

export default theme;
